/**
 * Convert TransactionIndex to number
 *
 * @param {import('./TransactionIndexType.js').TransactionIndexType} index
 * @returns {number}
 */
export function toNumber(index) {
	return index;
}
